import React, { useState, useEffect } from 'react';
import { Modal, Button } from "react-bootstrap";
import { BASE_URL } from "../../../constants";
import axios from 'axios';

//const DiscountModal = ({ show, handleClose, handleSave }) => {
const EditAllotParkModal = ({ show, handleClose, onRowSelect }) => {

  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    
    const fetchLists = async () => {
      try {

        const response = await axios.get(`${BASE_URL}/api/get_cashbank_edit`);

        setSearchResults(response.data);


      } catch (err) {
        console.error("Populate error:", err);
      }
    };

    fetchLists();

  }, []);

  // const handleRowClick = async (rowData) => {
  // };

  // const handleSearch = async () => {
  //   try {
  //     const response = await axios.get(`${BASE_URL}/api/get_cashbank_edit`, {
  //       params: {searchParkType : 0, searchLevel: '', searchVehType: ''},
  //     });

  //     setSearchResults(response.data);

  //   } catch (error) {
  //     console.error('Search failed:', error);
  //   }
  // };

  return (
      <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Select Cash Bank Master</Modal.Title>
        </Modal.Header>

        <Modal.Body>
{/*           
          <Form className="mb-3 d-flex gap-3">
            <Form.Group>
              <Form.Label>Parking Type</Form.Label>
              <select className="form-control" name="searchParkType" value={searchParkType} 
                onChange={(e) => setSearchParkType(e.target.value)} style={{width: '300px'}}>
              <option value="">-- Select Parking Type --</option>
                 {parkingTypes.map((pt) => (
                 <option key={pt.ptype_id} value={pt.ptype_id}>{pt.ptype_name}</option>
                  ))}
              </select>
            </Form.Group>

            <Form.Group>
              <Form.Label>Level</Form.Label>
              <select className="form-control" name="searchLevel" value={searchLevel} 
              onChange={(e) => setSearchLevel(e.target.value)} style={{width: '110px'}} >
              <option value="">-- Select Level --</option>
              {levels.map((lvl) => (
                <option key={lvl.level} value={lvl.level}>{lvl.level}</option>
              ))}
            </select>
            </Form.Group>

            <Form.Group>
              <Form.Label>Flat No</Form.Label>
              <select className="form-control" name="searchVehType" value={searchVehType} 
              onChange={(e) => setSearchVehType(e.target.value)} style={{width: '200px'}}>
                 <option value="">-- Select Vehicle Type --</option>
                 <option value="4WHLR">Four-Wheeler</option>
                 <option value="2WHLR">Two-Wheeler</option>
              </select>
            </Form.Group>

            <div className="align-self-end">
              <Button variant="primary" onClick={handleSearch}>Search</Button>
            </div>
          </Form> */}

          {/* <Table bordered hover responsive> */}
          <div style={{ minHeight: '430px' }} className="table-wrapper">
            <table style={{ maxHeight: '35px' }} className="responsive-table-modal scty-custom-table">
              <thead>
                <tr>
                  <th style={{width: '20%', textAlign: 'left' }}>Cash/Bank Title</th>
                  <th style={{width: '20%', textAlign: 'left' }}>Bank Name</th>
                  <th style={{width: '15%', textAlign: 'left' }}>Account No.</th>
                  <th style={{width: '10%', textAlign: 'left' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {searchResults.length === 0 ? (
                  <tr><td colSpan="4" className="text-center">No data</td></tr>
                ) : (
                  searchResults.map((row, index) => (
                    <tr key={index} onClick={() => onRowSelect(row)} style={{ cursor: 'pointer' }}>
                      <td style={{textAlign: 'left' }}>{row.cb_title}</td>
                      <td style={{textAlign: 'left' }}>{row.bank_name}</td>
                      <td style={{textAlign: 'left' }}>{row.bank_acc_no}</td>
                      <td style={{textAlign: 'left' }}>{row.acct_status}</td>
                    </tr>
                  ))
                )}
              </tbody>
              {/* </Table> */}
            </table>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
  );
};

export default EditAllotParkModal;
